export const DefaultConfig = {
  DISPLAY_AVG_DEPTH_AND_TOTAL_STORES_IN_QTY_VIEW: 'false',
  CENTRAL_WHL_PRICELIST_GROUP: 'GIV_VIPPriceListGroup:EO',
  CENTRAL_WHL_PRICELIST_TYPE: 'GIV_VIPPriceListType:ZWHL',
  CENTRAL_SRP_PRICELIST_GROUP: 'GIV_VIPPriceListGroup:U1',
  CENTRAL_SRP_PRICELIST_TYPE: 'GIV_VIPPriceListType:ZSRP',
  CENTRAL_RETAIL_PRICELIST_GROUP: 'GIV_VIPPriceListGroup:01',
  CENTRAL_RETAIL_PRICELIST_TYPE: 'GIV_VIPPriceListType:ZRET',
  CENTRAL_CUSTOM_SRP_PRICELIST_GROUP: 'GIV_VIPPriceListGroup:U1',
  CENTRAL_CUSTOM_SRP_PRICELIST_TYPE: 'GIV_VIPPriceListType:ZSRP',
  GLOBAL_CURRENCY: 'EUR',
  QUANTITY_TYPE: {
    Retail: 'LINE_ITEM_SIZE_QUANTITY',
    Wholesale: 'LINE_ITEM_SIZE_QUANTITY'
  },
  BULK_UPDATE_CLUSTER_EXCLUSION: 'false',
  INTEGRATION_SETTINGS_IMPORT: 'false',
  INTEGRATION_SETTINGS_EXPORT: 'false',
  INTEGRATION_SETTINGS_EXPORT_ORDER_ON_REVIEW: 'false',
  PDF_EXPORT_MAX_LIMIT: 10,
  LOCALIZATION_DEFAULT_NAMESPACE: 'translations',
  LOCALIZATION_FALLBACK_NAMESPACE: 'translation',
  LOCALIZATION_DEFAULT_LANGUAGE: 'en',
  LOCALIZATION_FALLBACK_LANGUAGE: 'en',
  LOCALIZATION_SAVE_MISSING: 'false',
  LOCALIZATION_SOURCE: 'local',
  LOCALIZATION_LOCIZE_VERSION: 'latest',
  LOCALIZATION_LOCIZE_PRIVATE: 'false',
  LOCALIZATION_LOCIZE_REF_LANGUAGE: 'en',
  LOCALIZATION_CURRENCY_DISPLAY_FORMAT: 'symbol',
  RETAIL_ASSORTMENT_SOURCE: 'CLUSTER',
  WHOLESALE_ASSORTMENT_SOURCE: 'CLUSTER',
  VIP_RANGE_PLAN_BUSINESS_HIERARCHY: 'CLIENT'
}
